export default __webpack_public_path__ + "static/media/491.72376d6c.png";